import {defaultLocale, isSupportedLocale} from "~/strings/global";

export function normalizeLangParam(lang?: string | null) {
  return isSupportedLocale(lang ?? "") ? (lang as typeof defaultLocale) : defaultLocale;
}

export function getLangPrefix(lang?: string | null) {
  return `/${normalizeLangParam(lang)}`;
}
